<template>
	<LabeledFieldLayout class="recurrence-time-picker-field"
		:is-valid="isValid"
		:validation-error="{ message: !isValid }"
	>
		<template #default>
			<div class="fields">
				<div class="time-fields">
					<TeamingDropDown
						class="time"
						name="timeField"
						:options="timeOptions"
						:value="timeField"
						@change="onTimeChange"
					/>
					<MeridiemDropDown
						class="ampm"
						name="meridiemField"
						:value="meridiemField"
						@change="onMeridiemChange"
					/>
				</div>
				<TimeZoneTypeAhead
					class="timezone"
					name="timezoneField"
					:timezones="timezones"
					:value="timezoneField"
					@change="onTimeZoneChange"
				/>
			</div>
		</template>
		<template #validationError>
			<div v-for="fieldError in fieldErrors" :key="fieldError.message">
				{{ fieldError.message }}
			</div>
		</template>
	</LabeledFieldLayout>
</template>

<script>
/* eslint-disable no-magic-numbers */
import {
	FormMixin,
	LabeledFieldLayout,
	TeamingDropDown,
	TimeZoneTypeAhead,
	MeridiemDropDown,
	makeTeamingDropDownOption
} from "@teaming/common-ui";

export default {
	name: "RecurrenceTimePickerField",
	teamingPackage: "common-team",
	mixins: [ FormMixin, ],
	components: {
		LabeledFieldLayout,
		TeamingDropDown,
		TimeZoneTypeAhead,
		MeridiemDropDown,
	},
	props: {
		meridiemField: {
			type: String,
			required: true,
		},
		timeField: {
			type: String,
			required: true,
		},
		times: {
			type: Array,
			required: true,
		},
		timezoneField: {
			type: String,
			required: true,
		},
		timezones: {
			type: Array,
			required: true,
		},
	},
	computed: {
		/** @override */
		// eslint-disable-next-line vue/no-unused-properties
		form() {
			const {
				timeField,
				timezoneField,
				meridiemField,
			} = this;

			return {
				timeField,
				timezoneField,
				meridiemField,
			};
		},
		timeOptions() {
			return this.times.map( time => makeTeamingDropDownOption( {
				text: time,
				value: time,
			} ) );
		},
		isValid() {
			const { errors, } = this;
			return !(
				errors.timeField ||
				errors.meridiemField ||
				errors.timezoneField
			);
		},
		fieldErrors() {
			const { errorFor, } = this;
			return [
				errorFor( "timeField" ),
				errorFor( "meridiemField" ),
				errorFor( "timezoneField" ),
			].filter( e => !!e.message );
		},
	},
	methods: {
		onTimeChange( { value: timeField, } ) {
			this.raiseFormChange( { timeField, } );
		},
		onMeridiemChange( { value: meridiemField, } ) {
			this.raiseFormChange( { meridiemField, } );
		},
		onTimeZoneChange( { value: timezoneField, } ) {
			this.raiseFormChange( { timezoneField, } );
		},
	},
};
</script>

<style lang="scss" scoped>
.recurrence-time-picker-field .fields {
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	gap: 0.5rem;

	.time-fields {
		flex: 2;
	}

	.timezone {
		flex: 3;
	}

	@include for-size('sm') {
		flex-direction: row;
	}
}

.recurrence-time-picker-field .time-fields {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	gap: 0.5rem;

	.time, .ampm {
		flex: 1
	}
}
</style>

<style lang="scss">
.recurrence-time-picker-field {
	.teaming-drop-down__options,
	.teaming-type-ahead__options {
		max-height: 8rem;
		overflow: auto;
	}
}
</style>
